import * as Yup from "yup"
import { validNumber, validString } from "Components/shared/helpers/validations"
import { reverseShape } from "Helpers/reverse-shape"

const PaymentDetailsSchema = Yup.object().shape(
    reverseShape({
        bankType:validString.optional(),
        accountNo:validString.optional(),
        socsoNo:validString.length(12).optional(),
        epfNo:validString.length(8).optional(),
        incomeTax:validString.optional(),
        hrdfNo:validString.length(9).optional(),
        zakatNo:validString.optional(),
    })
)

export default PaymentDetailsSchema
